export const courseSteps = [
  {
    id: '1',
    data: 'Course Information',
    number: 1
  },
  {
    id: '2',
    data: 'Course Content',
    number: 2
  }
];
